export function isClientError(status: number): boolean {
    return status >= 400 && status < 500;
}

export function isServerError(status: number): boolean {
    return status >= 500 && status < 600;
}

export function isSessionExpired(status: number): boolean {
    return 419 === status;
}
